// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"modal-title__modal-title___1fyar"};